<template>
  <v-text-field
    label="First Names"
    v-model="profile.firstNames"
    :loading="loading"
    @blur="submit"
    :color="themes.candidate.light.input"
    hint="Adding all your given names will help distinguish you from another candidate, especially if you have a common name." 
    @input="fixCase"
  />
</template>

<script>
// Mixins
import { caseConverters } from '@/mixins/caseConverters.js'

// Vue Component
export default {
  mixins: [caseConverters],

  props: ['value'],
  data() {
    return {
      // Loading indicator
      loading: false,
      // Model (object sent to API)
      profile: {
        firstNames: this.value
      }
    }
  },
  methods: {
    fixCase() {
      this.profile.firstNames = this.toTitleCase(this.profile.firstNames)
    },

    submit() {
      if (this.value !== this.profile.firstNames) {
        this.loading = true
        this.$store.dispatch('candidate/profile/update', this.profile).then(() => (this.loading = false))
      }
    }
  }
}
</script>
